import React, { Suspense } from 'react';
import { useApp } from '@/contexts/AppContext';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { DiagramPayload } from '@/services/diagramChatService';

const DiagramViewer = React.lazy(() => import('@/components/diagram/DiagramViewer'));

interface DiagramTabProps {
  draftId?: number;
  onDiagramUpdated?: (payload: DiagramPayload) => void;
}

export default function DiagramTab({ draftId, onDiagramUpdated }: DiagramTabProps) {
  const { currentDiagram } = useApp();

  if (!currentDiagram) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Diagrams</CardTitle>
        </CardHeader>
        <CardContent>
          No project loaded.
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between w-full">
            <CardTitle>Diagrams</CardTitle>
            <div className="text-sm text-muted-foreground">Using current selection from top bar</div>
          </div>
        </CardHeader>
        <CardContent>
          <div className="text-sm text-muted-foreground mb-4">Showing: {currentDiagram.name}</div>
          <Suspense fallback={<div>Loading diagram...</div>}>
            <DiagramViewer
              diagram={currentDiagram}
              draftId={draftId}
              onDiagramUpdated={onDiagramUpdated}
            />
          </Suspense>
        </CardContent>
      </Card>
    </div>
  );
}
